// Module
var code = "<md-button class=\"md-icon-button\" ng-click=\"$ctrl.showDialog($event)\"> <md-icon class=\"o-configuration-1 tmr-icon-24 md-warn\"></md-icon> <md-tooltip md-direction=\"right\">{{'DEBUGDIALOG.BUTTON' | translate}}</md-tooltip> </md-button> ";
// Exports
var _module_exports =code;;
var path = 'components/dialogs/debugDialog/debugDialog.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;